import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmThresholdDay {
    DayText:  string;
    DayValue: number;

    constructor(
         pDayText:  string
        ,pDayValue: number
    ) {
        this.DayText  = pDayText;
        this.DayValue = pDayValue;
    }
}

export class dmThresholdHour {
    HourText:  string;
    HourValue: number;

    constructor(
         pHourText:  string
        ,pHourValue: number
    ) {
        this.HourText  = pHourText;
        this.HourValue = pHourValue;
    }
}

export class CancellationViewModel {
    ShowAlert:             (pTitle: string, pMessage: string) => void;
    BackToSignIn:          ()                                 => void;
    NewLoading:            (pMessage: string)                 => dmLoading;
                           
    mlText:                MLText;
    app:                   mlBroker;
    ml:                    mlBroker;
    Hotel:                 dmHotel;
    LangID:                number;

    InAction:              boolean;
    NoActivePolicy:        boolean;

    CPolicyID:             number;
    CurrentCPolicy:        string[];

    PenaltyTypeID:         number;
    Percentage:            number;
    ThresholdDay:          number;
    ThresholdHour:         number;
    IsNoShowNonRefundable: boolean;

    IsPenaltyEnabled:      boolean;
    IsPercentageEnabled:   boolean;
    IsThresholdEnabled:    boolean;
    Is24thHourEnabled:     boolean;

    WithThreshold:         boolean;

    PercentageSelected:    number;
    ThresholdDaySelected:  number;
    ThresholdHourSelected: number;

    ThresholdDays:         dmThresholdDay[];
    ThresholdHours:        dmThresholdHour[];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText         = pMLText;
        this.LangID         = this.mlText.GetLangID();
        this.app            = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml             = this.mlText.GetBroker(
            'HotelAreaCancellation'
        );

        this.Hotel          = pHotel;
        this.BackToSignIn   = pBackToSignIn;
        this.ShowAlert      = pShowAlert;
        this.NewLoading     = pNewLoading;

        this.InAction       = false;
        this.NoActivePolicy = false;

        this.CPolicyID      = 0;
        this.CurrentCPolicy = [];
        this.PenaltyTypeID  = 0;
        this.Percentage     = 0;
        this.ThresholdDay   = 0;
        this.ThresholdHour  = 24;

        this.IsNoShowNonRefundable = false;

        this.IsThresholdEnabled    = false;
        this.IsPercentageEnabled   = false;
        this.Is24thHourEnabled     = true;

        this.WithThreshold         = false;

        this.PercentageSelected    = 20;
        this.ThresholdDaySelected  = 1;
        this.ThresholdHourSelected = 12;

        let loading         = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.ThresholdDays  = [];
            this.ThresholdHours = [];
            
            let checkinDate = new dmThresholdDay(
                 this.ml.Text('OnTheCheckInDate' ,'on the check-in date')
                ,0
            );
            
            let oneDayPrior = new dmThresholdDay(
                 this.ml.Text('OneDayPrior'      ,'1 day prior to the check-in date')
                ,1
            );
            
            this.ThresholdDays.push(checkinDate);
            this.ThresholdDays.push(oneDayPrior);
            
            for (let i: number = 2; i <= 90; i++) {
                this.ThresholdDays.push(
                    new dmThresholdDay(
                        i.toString() + ' ' + this.ml.Text(
                             'DaysPrior'
                            ,'days prior to the check-in date'
                        )
                        ,i
                    )
                );
            }
            
            this.populateThresholdHours();
            
            this.reloadCPolicy(() => {
                loading.Dismiss();
            
                this.InAction = false;
            });
        });
    }

    private populateThresholdHours() {
        this.ThresholdHours.push(new dmThresholdHour(
             '1 ' + this.ml.Text('AM', 'a.m.')
            ,1
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '2 ' + this.ml.Text('AM', 'a.m.')
            ,2
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '3 ' + this.ml.Text('AM', 'a.m.')
            ,3
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '4 ' + this.ml.Text('AM', 'a.m.')
            ,4
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '5 ' + this.ml.Text('AM', 'a.m.')
            ,5
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '6 ' + this.ml.Text('AM', 'a.m.')
            ,6
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '7 ' + this.ml.Text('AM', 'a.m.')
            ,7
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '8 ' + this.ml.Text('AM', 'a.m.')
            ,8
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '9 ' + this.ml.Text('AM', 'a.m.')
            ,9
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '10 ' + this.ml.Text('AM', 'a.m.')
            ,10
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '11 ' + this.ml.Text('AM', 'a.m.')
            ,11
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             this.ml.Text('Midday', 'midday')
            ,12
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '1 ' + this.ml.Text('PM', 'p.m.')
            ,13
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '2 ' + this.ml.Text('PM', 'p.m.')
            ,14
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '3 ' + this.ml.Text('PM', 'p.m.')
            ,15
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '4 ' + this.ml.Text('PM', 'p.m.')
            ,16
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '5 ' + this.ml.Text('PM', 'p.m.')
            ,17
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '6 ' + this.ml.Text('PM', 'p.m.')
            ,18
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '7 ' + this.ml.Text('PM', 'p.m.')
            ,19
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '8 ' + this.ml.Text('PM', 'p.m.')
            ,20
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '9 ' + this.ml.Text('PM', 'p.m.')
            ,21
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '10 ' + this.ml.Text('PM', 'p.m.')
            ,22
        ));

        this.ThresholdHours.push(new dmThresholdHour(
             '11 ' + this.ml.Text('PM', 'p.m.')
            ,23
        ));
    }

    private reloadCPolicy(pAction: () => void): void {
        let cpolicyDescriptionParams = RQParam.OtaGetHotelCPolicyParams();

        cpolicyDescriptionParams.HotelID = this.Hotel.HotelID;
        cpolicyDescriptionParams.LangID  = this.LangID;

        this.NoActivePolicy = false;

        this.CurrentCPolicy.length = 0;

        RQService.Ota.GetHotelCPolicy(cpolicyDescriptionParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let cpolicyTexts = response.RQueryResult;

            for (let i = 0; i < cpolicyTexts.length; i++) {
                let cpolicyText = RQService.Ota.PopulateGetHotelCPolicyRow(
                    cpolicyTexts[i]
                );

                if (cpolicyText.CPolicyText == '') {
                    this.NoActivePolicy = true;

                    cpolicyText.CPolicyText = this.ml.Text(
                         'NoActivePolicy'
                        ,'No active cancellation policy'
                    );
                }

                console.log('row push');

                this.CurrentCPolicy.push(cpolicyText.CPolicyText);
            }

            let cpolicyParams = RQParam.PmsGetCPolicyByOfferTypeIDParams();

            cpolicyParams.HotelID     = this.Hotel.HotelID;
            cpolicyParams.OfferTypeID = 1;

            RQService.Pms.GetCPolicyByOfferTypeID(cpolicyParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { return; }

                let cpolicy  = RQService.Pms.PopulateGetCPolicyByOfferTypeIDRow(
                    response.RQueryResult[0]
                );

                this.CPolicyID     = cpolicy.CPolicyID;
                this.PenaltyTypeID = cpolicy.PenaltyTypeID;
                this.Percentage    = cpolicy.Percentage;
                this.ThresholdDay  = cpolicy.ThresholdDay;
                this.ThresholdHour = cpolicy.ThresholdHour;

                this.IsNoShowNonRefundable
                    = (cpolicy.IsNoShowNonRefundable == 0)
                    ? false
                    : true;

                this.IsPercentageEnabled = (this.PenaltyTypeID == 2);

                this.IsThresholdEnabled  = (
                    (this.PenaltyTypeID == 1)
                ||  (this.PenaltyTypeID == 2)
                );

                this.WithThreshold = (
                    this.IsThresholdEnabled
                && !(
                        (this.ThresholdHour == 24)
                    &&  (this.ThresholdDay  == 0)
                    )
                );

                if (this.IsPercentageEnabled) { this.PercentageSelected = this.Percentage; }
                if (this.WithThreshold)       {
                    this.ThresholdDaySelected  = this.ThresholdDay;
                    this.ThresholdHourSelected = this.ThresholdHour;

                    if (this.ThresholdDay == 0) {
                        this.Is24thHourEnabled = false;
                    } else {
                        this.Is24thHourEnabled = true;
                    }
                }

                pAction();
            });
        });
    }

    public SaveCPolicy() {
        if (this.InAction) { return; }

        if (this.PenaltyTypeID == 0) {
            this.ShowAlert(
                 this.ml.Text('ChangesNotSaved' ,'Changes Not Saved')
                ,this.ml.Text(
                     'YouMustSelectAPenaltyType'
                    ,'You must select a penalty type'
                )
            );

            return;
        }

        this.PercentageSelected = Math.floor(this.PercentageSelected);

        if (
            this.PenaltyTypeID == 2
        &&  (
                this.PercentageSelected < 1
            ||  this.PercentageSelected > 100
            )
        ) {
            this.PercentageSelected = 20;

            this.ShowAlert(
                 this.ml.Text('ChangesNotSaved' ,'Changes Not Saved')
                ,this.ml.Text(
                     'PercentageMustBeBetween'
                    ,'Percentage must be a whole number between 1 and 100'
                )
            );

            return;
        }

        this.InAction   = true;

        let loading     = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            if (this.PenaltyTypeID == 2) {
                this.Percentage = this.PercentageSelected;
            } else {
                this.Percentage = 0;
            }
            
            if (
                (this.PenaltyTypeID == 1 || this.PenaltyTypeID == 2)
            &&  (this.WithThreshold)
            ) {
                this.ThresholdDay  = this.ThresholdDaySelected;
                this.ThresholdHour = this.ThresholdHourSelected;
            } else {
                this.ThresholdDay  = 0;
                this.ThresholdHour = 24;
            }
            
            let saveParams = RQParam.PmsCreateOrEditCPolicyByOfferTypeParams();
            
            saveParams.HotelID               = this.Hotel.HotelID;
            saveParams.OfferTypeID           = 1;
            saveParams.IsNonRefundable       = 0;
            saveParams.ThresholdDay          = this.ThresholdDay;
            saveParams.ThresholdHour         = this.ThresholdHour;
            saveParams.PenaltyTypeID         = this.PenaltyTypeID;
            saveParams.Percentage            = this.Percentage;
            saveParams.IsNoShowNonRefundable = (this.IsNoShowNonRefundable) ? 1 : 0;
            saveParams.LangID                = this.LangID;
            
            RQService.Pms.CreateOrEditCPolicyByOfferType(saveParams).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) { return; }
            
                this.CPolicyID = Number(response.RQueryResult[0].CPolicyID);
            
                this.reloadCPolicy(() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                });
            });
        });
    }

    public ChangePenaltyType(pPenaltyTypeID: number) {
        if (pPenaltyTypeID == 2) { this.IsPercentageEnabled = true;  }
        else                     { this.IsPercentageEnabled = false; }

        if (pPenaltyTypeID == 1 || pPenaltyTypeID == 2) {
            this.IsThresholdEnabled = true;
        } else {
            this.IsThresholdEnabled = false;
        }
    }

    public ChangeThresholdDay(pThresholdDay: number) {
        this.ThresholdDaySelected = pThresholdDay;

        if (
            this.ThresholdDaySelected  == 0
        &&  this.ThresholdHourSelected == 24
        ) {
            this.ThresholdHourSelected = 23;
        }

        if (this.ThresholdDaySelected == 0) {
            this.Is24thHourEnabled = false;
        } else {
            this.Is24thHourEnabled = true;
        }
    }

    public ChangeThresholdHour(pThresholdHour: number) {
        this.ThresholdHourSelected = pThresholdHour;
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/cancellation/xv-cancellation.ts